import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatRippleModule } from "@angular/material/core";
import { MatIconModule } from "@angular/material/icon";
import { EneButtonComponent } from "./button.component";

@NgModule({
  declarations: [EneButtonComponent],
  imports: [CommonModule, MatRippleModule, MatIconModule],
  exports: [EneButtonComponent]
})
export class EneButtonModule {}
